import React, { useState, useEffect } from "react";
import { database } from "../../firebase";
import { ref, onValue, remove, orderByChild, equalTo } from "firebase/database";
import { getFirestore, collection, getDocs, query, orderBy, doc, deleteDoc } from "firebase/firestore";
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GetAppIcon from '@mui/icons-material/GetApp';
import SnackbarWrapper from "../../components/Snackbar/SnackBarWrapper";
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import MuiAlert from '@mui/material/Alert';
import { StyledTableCell, StyledTableRow } from '../../utils/styled'
import { idCuadrillaNucleo, idCuadrillaBodega } from '../../utils/default'
import { utils, writeFile } from 'xlsx';
import { updateCuadrillaFirestore, getCuadrillasOnce } from '../../services/cuadrillasService';
import { Typography, Switch, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import moment from "moment";

const firestore = getFirestore();

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ListCuadrillas() {
    const [cuadrillas, setCuadrillas] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [cuadrillaToDelete, setCuadrillaToDelete] = useState(false);
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });
    const [precioFilter, setPrecioFilter] = useState([]);
    const [searchTitle, setSearchTitle] = useState('');
    const [filterSoloActivas, setFilterSoloActivas] = useState(true); // por defecto solo activas
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const isAdmin = currentUser?.rol === 'admin';

    const onDataChange = (items) => {
        setCuadrillas(items);
    };

    useEffect(() => {
        getCuadrillasOnce(onDataChange, { soloActivas: false }); // listado trae todas para poder filtrar y mostrar switch
    }, []);

    const handleToggleActiva = async (cuadrilla) => {
        const nuevaActiva = cuadrilla.activa !== false ? false : true;
        try {
            await updateCuadrillaFirestore(cuadrilla.id, { activa: nuevaActiva }, () => {
                setCuadrillas(prev => prev.map(c => c.id === cuadrilla.id ? { ...c, activa: nuevaActiva } : c));
                setSnackbarInfo({ text: nuevaActiva ? 'Cuadrilla activada' : 'Cuadrilla desactivada', type: 'success', open: true });
            });
        } catch (e) {
            setSnackbarInfo({ text: 'Error al actualizar', type: 'error', open: true });
        }
    };

    const handleClose = () => {
        setOpenDeleteModal(false)
    }

    // const deleteCuadrilla = () => {
    //     remove(ref(database, 'cuadrillas/' + cuadrillaToDelete))
    //         .then(() => {
    //             setSnackbarInfo({ text: 'Eliminado correctamente!', type: 'success', open: true })
    //             setOpenDeleteModal(false);
    //             setTimeout(() => {
    //                 window.location.reload();
    //             }, 2500);
    //         })
    //         .catch((error) => {
    //             setOpenDeleteModal(false)
    //             setSnackbarInfo({ text: 'Ocurrió un error', type: 'error', open: true })
    //         });
    // }

    const deleteCuadrilla = async () => {
        try {
            // Referencia al documento a eliminar en Firestore
            const docRef = doc(firestore, 'cuadrillas', String(cuadrillaToDelete));

            // Eliminar el documento
            await deleteDoc(docRef);

            // Mostrar mensaje de éxito
            setSnackbarInfo({ text: 'Eliminado correctamente!', type: 'success', open: true });
            setOpenDeleteModal(false);

            // Recargar la página después de 2.5 segundos (opcional)
            setTimeout(() => {
                window.location.reload();
            }, 2500);
        } catch (error) {
            // Manejar el error
            console.log('error', error);

            setOpenDeleteModal(false);
            setSnackbarInfo({ text: 'Ocurrió un error', type: 'error', open: true });
        }
    };

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    const exportToExcel = () => {
        try {
            // Filtrar cuadrillas (excluir núcleo y bodega); exportar lo que se muestra en tabla
            const cuadrillasToExport = displayTable.filter(cuadrilla => 
                cuadrilla.id !== idCuadrillaNucleo && cuadrilla.id !== idCuadrillaBodega
            );

            if (cuadrillasToExport.length === 0) {
                setSnackbarInfo({ text: 'No hay cuadrillas para exportar', type: 'warning', open: true });
                return;
            }

            // Definir encabezados de las columnas
            const headers = [
                'ID',
                'Código',
                'Número/Nombre',
                'Usuario',
                'Teléfono',
                'Correo Electrónico',
                'Chapa Móvil',
                'Aseguradora',
                ...(isAdmin ? ['% Participación'] : [])
            ];

            // Formatear datos para Excel
            const excelData = cuadrillasToExport.map(cuadrilla => {
                const row = {
                    'ID': cuadrilla.id,
                    'Código': cuadrilla.codigo || '',
                    'Número/Nombre': cuadrilla.numero || '',
                    'Usuario': cuadrilla.usuario || '',
                    'Teléfono': cuadrilla.nroTelefono || '',
                    'Correo Electrónico': cuadrilla.correoElectronico || '',
                    'Chapa Móvil': cuadrilla.chapaMovil || '',
                    'Aseguradora': cuadrilla.aseguradora || ''
                };
                if (isAdmin) {
                    row['% Participación'] = cuadrilla.porcentajeParticipacion || '';
                }
                return row;
            });

            // Crear libro de Excel
            const wb = utils.book_new();
            const ws = utils.json_to_sheet([]);
            
            // Agregar encabezados y datos
            utils.sheet_add_aoa(ws, [headers]);
            utils.sheet_add_json(ws, excelData, { origin: 'A2', skipHeader: true });
            
            // Agregar hoja al libro
            utils.book_append_sheet(wb, ws, 'Cuadrillas');
            
            // Generar nombre de archivo con fecha
            const dateNow = moment(new Date()).format("YYYYMMDD");
            const fileName = `cuadrillas-${dateNow}.xlsx`;
            
            // Descargar archivo
            writeFile(wb, fileName);
            
            setSnackbarInfo({ 
                text: `Archivo ${fileName} descargado exitosamente`, 
                type: 'success', 
                open: true 
            });

        } catch (error) {
            console.error('Error al exportar a Excel:', error);
            setSnackbarInfo({ 
                text: 'Error al generar el archivo Excel', 
                type: 'error', 
                open: true 
            });
        }
    };



    const baseList = searchTitle !== "" ? precioFilter : cuadrillas;
    const displayTable = filterSoloActivas
        ? baseList.filter(c => c.activa !== false)
        : baseList;

    return (
        <Container component="main" maxWidth="xl">
            <Typography variant="h5">Listado de cuadrillas</Typography>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Button variant="contained" href="/add-cuadrilla" style={{ marginRight: '10px' }}>Nueva</Button>
                    <Button
                        variant="outlined" 
                        onClick={exportToExcel}
                        disabled={cuadrillas.length === 0}
                        startIcon={<GetAppIcon />}
                        style={{ marginRight: '10px' }}
                    >
                        Descargar Excel
                    </Button>
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                        <InputLabel>Ver</InputLabel>
                        <Select
                            value={filterSoloActivas ? 'activas' : 'todas'}
                            label="Ver"
                            onChange={(e) => setFilterSoloActivas(e.target.value === 'activas')}
                        >
                            <MenuItem value="activas">Solo activas</MenuItem>
                            <MenuItem value="todas">Todas</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <TableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Id</StyledTableCell>
                            <StyledTableCell>Código</StyledTableCell>
                            <StyledTableCell>Número/Nombre</StyledTableCell>
                            <StyledTableCell>Usuario</StyledTableCell>
                            <StyledTableCell>Teléfono</StyledTableCell>
                            <StyledTableCell>Email</StyledTableCell>
                            <StyledTableCell>Chapa Móvil</StyledTableCell>
                            <StyledTableCell>Aseguradora</StyledTableCell>
                            {isAdmin && <StyledTableCell>% Particip.</StyledTableCell>}
                            <StyledTableCell>Activa</StyledTableCell>
                            <StyledTableCell>Acciones</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {cuadrillas &&
                            displayTable.map((cuadrilla, index) => (
                                (cuadrilla.id !== idCuadrillaNucleo && cuadrilla.id !== idCuadrillaBodega) &&
                                <StyledTableRow
                                    key={index}
                                    sx={cuadrillas?.deleted && { display: 'none' }}
                                >
                                    <StyledTableCell>{cuadrilla.id}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.codigo}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.numero}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.usuario || '-'}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.nroTelefono || '-'}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.correoElectronico || '-'}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.chapaMovil || '-'}</StyledTableCell>
                                    <StyledTableCell>{cuadrilla.aseguradora || '-'}</StyledTableCell>
                                    {isAdmin && <StyledTableCell>{cuadrilla.porcentajeParticipacion ? `${cuadrilla.porcentajeParticipacion}%` : '-'}</StyledTableCell>}
                                    <StyledTableCell>
                                        <Switch
                                            checked={cuadrilla.activa !== false}
                                            onChange={() => handleToggleActiva(cuadrilla)}
                                            color="primary"
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell className="column-actions">
                                        <IconButton
                                            aria-label="delete"
                                            className="action__link"
                                            href={`/cuadrilla/${cuadrilla.id}`}
                                            role="button"
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton
                                            aria-label="delete"
                                            type="button"
                                            className="action__button"
                                            onClick={() => {
                                                setOpenDeleteModal(true);
                                                setCuadrillaToDelete(cuadrilla.id)
                                            }}
                                        >
                                            <DeleteIcon sx={{ color: 'red' }} />
                                        </IconButton>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            

            <Dialog
                open={openDeleteModal}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Desea eliminar esta cuadrilla?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Los cambios serán permanentes.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cerrar</Button>
                    <Button onClick={deleteCuadrilla} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default ListCuadrillas;
